module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/flow_03_sp-99c487a02e9e6386988c6912247cce43.png";